const APIS = {
  DRIVER: '/fleetservice/api/driver/',
  VEHICLE: 'fleetservice/api/vehicle/',
  LOGISTIC_ORDER: '/logisticservice/api/order/',
  COMBINE_ORDERS: '/manifestservice/api/combined-orders/',
  COMBINE_ORDER_ITEMS: '/manifestservice/api/combined-order-items/',
};

export default APIS;
